import BlgInput from './Input';

export default BlgInput;
